var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnInit } from '@angular/core';
import { BpgMembershipService } from '../bpg-membership.service';
import { Leadership, LandingDTOModel, FilterModel } from "../../bpg-common/services/data.services";
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';
import { ConstantValues } from 'src/app/bpg-common/models/bpg-constants';
var BpgListComponent = /** @class */ (function () {
    /**
     * @class BpgListComponent
     * @constructor
     */
    function BpgListComponent(membershipService, router, spinnerService, environment) {
        this.membershipService = membershipService;
        this.router = router;
        this.spinnerService = spinnerService;
        this.environment = environment;
        this.selectedBpg = [];
        this.bpgList = [];
        this.savedData = JSON.parse(sessionStorage.getItem('MembershipData'));
        this.leadershipList = new Leadership();
        this.demographicsList = [];
        this.membershipDetails = [];
        this.userId = 1;
        this.loginData = JSON.parse(localStorage.getItem('loginData'));
        this.loginUserId = [];
        this.landingDTOModel = new LandingDTOModel();
        this.siteId1 = localStorage.getItem('userSiteId');
        this.filter = new FilterModel();
        this.timeoutErrorMessage = ConstantValues.timeoutErrorMessage;
        this.nobpgfound = false;
        this.isCorporateUser = false;
        this.showLeadership = false;
        this.roleList = [];
        this.chairs = [];
        this.viceChairs = [];
        this.communicationsChairs = [];
        this.financeChairs = [];
        this.newList = {};
        this.finalList = [];
    }
    BpgListComponent.prototype.ngOnInit = function () {
        localStorage.setItem('oneSkill', 'false');
        if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
            if (localStorage.getItem('loginData') === null || localStorage.getItem('loginData') === undefined) {
                this.router.navigate(['/log-out']);
            }
        }
        window.scrollTo(0, 0);
        localStorage.removeItem('searchedEventsCaledarItems');
        this.corporateType = (this.loginData.corporatePartnerType !== null && this.loginData.corporatePartnerType !== undefined) ? this.loginData.corporatePartnerType.trim() : '';
        if (this.corporateType.toUpperCase() === "CONTINGENT" || this.corporateType.toUpperCase() === "TECHNICAL CONTRACTOR") {
            this.isCorporateUser = true;
        }
        this.formData = [];
        if (this.savedData === null) {
            this.savedData = "default msg";
        }
        this.spinnerService.show();
        if (this.savedData[0].virtualBpg !== undefined) {
            this.virtualBpg = this.savedData[0].virtualBpg;
        }
        else {
            this.virtualBpg = undefined;
        }
        if (this.savedData[0].siteFormData !== undefined) {
            this.siteList = this.savedData[0].siteFormData;
        }
        else {
            this.siteList = null;
        }
        if (this.savedData[0].interestFormData !== undefined) {
            this.interestList = this.savedData[0].interestFormData;
        }
        else {
            this.interestList = [];
        }
        if (this.savedData[0].skillsFormData !== undefined) {
            this.skillsList = this.savedData[0].skillsFormData;
        }
        else {
            this.skillsList = [];
        }
        if (this.savedData[0].leadershipFormData !== undefined) {
            this.leadershipList = this.savedData[0].leadershipFormData;
        }
        else {
            this.leadershipList = null;
        }
        if (this.savedData[0].otherSkillsFormData !== undefined) {
            this.otherSKills = this.savedData[0].otherSkillsFormData;
        }
        else {
            this.otherSKills = null;
        }
        this.getBpgDetails();
    };
    /** To async the service call to get the bpg list with selected bpgs
     * @class BpgListComponent
     * @method getBpgDetails
     */
    BpgListComponent.prototype.getBpgDetails = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.virtualBpg) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.getVirtualBpgs()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.getBpgs()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    /** To async the service call to get the bpg list
     * @class BpgListComponent
     * @method getBpgs
     */
    BpgListComponent.prototype.getBpgs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.filter.siteId = String(this.siteList.siteId);
                        this.landingDTOModel.filter = this.filter;
                        return [4 /*yield*/, this.membershipService.getAllBpg(this.landingDTOModel).toPromise().then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.bpgList = data;
                                            if (this.bpgList.length > 0) {
                                                this.nobpgfound = false;
                                            }
                                            else {
                                                this.nobpgfound = true;
                                            }
                                            return [4 /*yield*/, this.getSelectedBpgs()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, function (err) {
                                _this.spinnerService.hide();
                                if (err.value.statusText === ConstantValues.unknownError) {
                                    _this.timeOutError = true;
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** To async the service call to get the bpg list of default site
     * @class BpgListComponent
     * @method getBpgs
     */
    BpgListComponent.prototype.getVirtualBpgs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        params = this.siteList.siteId + "/" + this.siteId1 + "/" + this.loginData.userId;
                        return [4 /*yield*/, this.membershipService.getAllVirtualBpg(params).toPromise().then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            this.bpgList = data;
                                            if (this.bpgList.length > 0) {
                                                this.nobpgfound = false;
                                            }
                                            else {
                                                this.nobpgfound = true;
                                            }
                                            return [4 /*yield*/, this.getSelectedBpgs()];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }, function (err) {
                                _this.spinnerService.hide();
                                if (err.value.statusText === ConstantValues.unknownError) {
                                    _this.timeOutError = true;
                                }
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** To async the service call to get the selected bpg list
     * @class BpgListComponent
     * @method getSelectedBpgs
     */
    BpgListComponent.prototype.getSelectedBpgs = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.membershipService.retrieveDetailsOfMembership(this.loginData.userId).toPromise().then(function (data) {
                            _this.membershipDetails = data;
                            sessionStorage.setItem("previousMembershipDetails", JSON.stringify(_this.membershipDetails));
                            if (_this.savedData[0].bpgFormData !== undefined && _this.savedData[0].bpgFormData.length > 0) {
                                for (var i = 0, len = _this.bpgList.length; i < len; i++) {
                                    for (var j = 0, len_1 = _this.savedData[0].bpgFormData.length; j < len_1; j++) {
                                        if (_this.bpgList[i].bpgId === _this.savedData[0].bpgFormData[j].bpgId) {
                                            _this.bpgList[i].checked = true;
                                            _this.selectedBpg.push(_this.bpgList[i]);
                                        }
                                    }
                                }
                            }
                            if (_this.savedData[0].bpgFormData !== undefined && _this.savedData[0].bpgFormData.length > 0) {
                                for (var j = 0; j < _this.savedData[0].bpgFormData.length; j++) {
                                    var bpgname = _this.savedData[0].bpgFormData[j].bpgName;
                                    if (_this.selectedBpg[j].bpgName === bpgname) {
                                        _this.selectedBpg[j].showLeadership = true;
                                        _this.chairs[bpgname] = _this.savedData[0].bpgFormData[j].chairs;
                                        _this.selectedBpg[j].chairs = _this.savedData[0].bpgFormData[j].chairs;
                                        _this.viceChairs[bpgname] = _this.savedData[0].bpgFormData[j].viceChairs;
                                        _this.selectedBpg[j].viceChairs = _this.savedData[0].bpgFormData[j].viceChairs;
                                        _this.communicationsChairs[bpgname] = _this.savedData[0].bpgFormData[j].communicationsChairs;
                                        _this.selectedBpg[j].communicationsChairs = _this.savedData[0].bpgFormData[j].communicationsChairs;
                                        _this.financeChairs[bpgname] = _this.savedData[0].bpgFormData[j].financeChairs;
                                        _this.selectedBpg[j].financeChairs = _this.savedData[0].bpgFormData[j].financeChairs;
                                    }
                                }
                            }
                            if (_this.membershipDetails['selectedBpg'].length > 0 && (_this.membershipDetails['selectedBpg'] !== undefined && _this.membershipDetails['selectedBpg'] != null) && _this.savedData[0].bpgFormData.length === 0) {
                                var selectList = _this.bpgList;
                                for (var _i = 0, _a = _this.membershipDetails['selectedBpg']; _i < _a.length; _i++) {
                                    var bpg = _a[_i];
                                    for (var _b = 0, selectList_1 = selectList; _b < selectList_1.length; _b++) {
                                        var select = selectList_1[_b];
                                        if (bpg.bpgName === select.bpgName) {
                                            select.chairs = bpg.isChair;
                                            select.viceChairs = bpg.isViceChair;
                                            select.communicationsChairs = bpg.isCommunicationChair;
                                            select.financeChairs = bpg.isFinanceChair;
                                            _this.chairs[select.bpgName] = bpg.isChair;
                                            _this.viceChairs[select.bpgName] = bpg.isViceChair;
                                            _this.communicationsChairs[select.bpgName] = bpg.isCommunicationChair;
                                            _this.financeChairs[select.bpgName] = bpg.isFinanceChair;
                                            select.showLeadership = true;
                                            select.checked = true;
                                            _this.selectedBpg.push(select);
                                        }
                                    }
                                }
                            }
                            if (_this.membershipDetails['bpgIds'].length > 0) {
                                for (var i = 0, len = _this.bpgList.length; i < len; i++) {
                                    for (var j = 0, len_2 = _this.membershipDetails['bpgIds'].length; j < len_2; j++) {
                                        if (_this.bpgList[i].bpgId === _this.membershipDetails['bpgIds'][j]) {
                                            _this.bpgList[i].checked = true;
                                            _this.bpgList[i].showLeadership = true;
                                            _this.selectedBpg.push(_this.bpgList[i]);
                                        }
                                    }
                                }
                            }
                            _this.spinnerService.hide();
                        }, function (err) {
                            _this.spinnerService.hide();
                            if (err.value.statusText === ConstantValues.unknownError) {
                                _this.timeOutError = true;
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /** To send data to next page
     * @class BpgListComponent
     * @method sendData
     */
    BpgListComponent.prototype.sendData = function () {
        this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.selectedBpg, interestFormData: this.interestList, skillsFormData: this.skillsList, leadershipFormData: this.leadershipList, otherSkillsFormData: this.otherSKills });
        sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
        this.router.navigate(['membership/interests']);
        window.scrollTo(0, 0);
    };
    BpgListComponent.prototype.assignroles = function (event, data) {
        var bpgName = data.bpgName;
        if (event.target.checked) {
            for (var _i = 0, _a = this.selectedBpg; _i < _a.length; _i++) {
                var bpg = _a[_i];
                if (bpgName === bpg.bpgName) {
                    if (this.chairs[bpgName]) {
                        bpg.chairs = true;
                    }
                    if (this.viceChairs[bpgName]) {
                        bpg.viceChairs = true;
                    }
                    if (this.communicationsChairs[bpgName]) {
                        bpg.communicationsChairs = true;
                    }
                    if (this.financeChairs[bpgName]) {
                        bpg.financeChairs = true;
                    }
                }
            }
        }
        else {
            for (var _b = 0, _c = this.selectedBpg; _b < _c.length; _b++) {
                var bpg1 = _c[_b];
                if (bpgName === bpg1.bpgName) {
                    if (!this.chairs[bpgName]) {
                        bpg1.chairs = false;
                    }
                    if (!this.viceChairs[bpgName]) {
                        bpg1.viceChairs = false;
                    }
                    if (!this.communicationsChairs[bpgName]) {
                        bpg1.communicationsChairs = false;
                    }
                    if (!this.financeChairs[bpgName]) {
                        bpg1.financeChairs = false;
                    }
                }
            }
        }
    };
    /** to select the checkbox
     * @class BpgListComponent
     * @method toggleCheckbox
     */
    BpgListComponent.prototype.toggleCheckbox = function (event, data) {
        if (event.target.checked) {
            this.selectedBpg.push(data);
            for (var i = 0; i < this.bpgList.length; i++) {
                if (this.bpgList[i].bpgName === data.bpgName) {
                    this.bpgList[i] = Object.assign(this.bpgList[i], {
                        'showLeadership': true,
                    });
                }
            }
            for (var j = 0; j < this.selectedBpg.length; j++) {
                if (this.selectedBpg[j].bpgName === data.bpgName) {
                    this.selectedBpg[j] = Object.assign(this.selectedBpg[j], {
                        chairs: false, communicationsChairs: false, financeChairs: false, viceChairs: false
                    });
                }
            }
        }
        else {
            var index = this.selectedBpg.indexOf(data);
            if (index !== -1) {
                this.selectedBpg.splice(index, 1);
                for (var i = 0; i < this.bpgList.length; i++) {
                    if (this.bpgList[i].bpgName === data.bpgName) {
                        this.bpgList[i] = Object.assign(this.bpgList[i], {
                            'showLeadership': false,
                        });
                    }
                }
            }
        }
    };
    /** To send data to previous page
     * @class BpgListComponent
     * @method redirectToSite
     */
    BpgListComponent.prototype.redirectToSite = function () {
        localStorage.setItem('status', 'true');
        this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.siteList, bpgFormData: this.selectedBpg, interestFormData: this.interestList, skillsFormData: this.skillsList, leadershipFormData: this.leadershipList, otherSkillsFormData: this.otherSKills });
        sessionStorage.setItem("MembershipData", JSON.stringify(this.formData));
        window.scrollTo(0, 0);
    };
    return BpgListComponent;
}());
export { BpgListComponent };
